<template>
  <create-target-slot
    :title="title"
    :showBackButton="showBackButton"
    :png="dataSourceIcon">
    <create-ad
      :targetName="targetName"
      :onComplete="onComplete"
    />
  </create-target-slot>
</template>

<script>
import CreateTargetSlot from './CreateTargetSlot'
import CreateAd from '../forms/CreateAd'
import ADIcon from '@/assets/targetImages/Audience.svg'

export default {
  components: {
    CreateTargetSlot,
    CreateAd
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: false
    },
    targetName: {
      type: String,
      default: ''
    },
    onComplete: {
      type: Function,
      default: () => {}
    },
    dataSourceIcon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'New Audience Discovery Target'
    }
  },
  data () {
    return {
      svg: ADIcon
    }
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// CreateADTargetSlot.vue?07ed0b0e